import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7e56a2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "classes-page"
}
const _hoisted_2 = { class: "grade-group__title" }

import MinorCard from '@/common/components/snedson-material-components/minor-card/minor-card.vue';
import { SchoolClassModel } from '@/models/SchoolClassModel';
import { onMounted, reactive } from 'vue';
import { getSchoolClassesPage } from './api-methods';
import { GradeTitles, SchoolClassesPageState } from './ClassesListPage.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassesListPage',
  setup(__props) {

const state = reactive<{
    schoolClasses: SchoolClassesPageState;
}>({
    schoolClasses: {},
});

onMounted(() => {
    getSchoolClassesPage().then((res) => {
        state.schoolClasses = groupSchoolClassesByGrade(res.data.schoolClasses);
    });
});

const groupSchoolClassesByGrade = (
    classes: SchoolClassModel[]
): SchoolClassesPageState => {
    const groupedClasses: SchoolClassesPageState = {};

    classes
        .filter((sc) => !sc.isMockClass)
        .forEach((schoolClass) => {
            const gradeNumber = schoolClass.gradeNumber;
            if (groupedClasses[gradeNumber]) {
                groupedClasses[gradeNumber].push(schoolClass);
            } else {
                groupedClasses[gradeNumber] = [schoolClass];
            }
        });

    return groupedClasses;
};

return (_ctx: any,_cache: any) => {
  return (state.schoolClasses)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.schoolClasses, (Classes, GradeNumber) => {
          return (_openBlock(), _createElementBlock("ul", {
            key: GradeNumber,
            class: "classes-page__grade-group grade-group"
          }, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(GradeTitles)[GradeNumber]), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Classes, (schoolClass) => {
              return (_openBlock(), _createElementBlock("li", {
                key: schoolClass.classId,
                class: "grade-group__item"
              }, [
                _createVNode(MinorCard, {
                  props: {
                        title: schoolClass.className,
                        to: `/teacher/classes/${schoolClass.classId}/allStudents`,
                        icon: 'supervised_user_circle',
                    },
                  class: _normalizeClass(schoolClass.colorSchemeName)
                }, null, 8, ["props", "class"])
              ]))
            }), 128))
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})